import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Components/App';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import NavBar from "./Components/Nav/NavBar";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <NavBar />
        <Routes>
            <Route path="/" element={<App/>}/>
        </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
